function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PathsLog = /*#__PURE__*/function () {
  function PathsLog(mod) {
    _classCallCheck(this, PathsLog);
    this.mod = mod;
  }
  return _createClass(PathsLog, [{
    key: "pending",
    value: function pending() {
      if (!this.mod.game.state.pending_movement_log) {
        this.mod.game.state.pending_movement_log = [];
      }
      return this.mod.game.state.pending_movement_log;
    }
  }, {
    key: "label",
    value: function label(name) {
      var match = /^([A-Z]{2,}) Army$/.exec(name || '');
      if (match) {
        return match[1];
      }
      return name || '';
    }
  }, {
    key: "sideName",
    value: function sideName(faction) {
      if (faction === 'central') {
        return 'Central Powers';
      }
      return 'Allied Powers';
    }

    // Record one committed hop. Later hops by the same unit keep the first origin.
  }, {
    key: "noteMove",
    value: function noteMove(faction, sourcekey, sourceidx, destinationkey) {
      if (destinationkey === 'aeubox' || destinationkey === 'ceubox') {
        return false;
      }
      var space = this.mod.game.spaces[sourcekey];
      if (!space || !space.units || sourceidx < 0 || sourceidx >= space.units.length) {
        return false;
      }
      var unit = space.units[sourceidx];
      if (!unit) {
        return false;
      }
      var from = this.mod.returnSpaceNameForLog(sourcekey);
      var to = this.mod.returnSpaceNameForLog(destinationkey);
      var rows = this.pending();
      var existing = null;
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].key === unit.key) {
          existing = rows[i];
          break;
        }
      }
      if (existing) {
        existing.to = to;
      } else {
        rows.push({
          key: unit.key,
          faction: faction,
          unit: this.label(unit.name),
          from: from,
          to: to
        });
      }
      return true;
    }
  }, {
    key: "commitMove",
    value: function commitMove(faction, sourcekey, sourceidx, destinationkey) {
      var combat = this.mod.game.state && this.mod.game.state.combat;
      if (combat && combat.retreat_sourcekey === sourcekey && combat.retreat_destinationkey === destinationkey) {
        this.attachRetreat(faction, destinationkey);
        combat.retreat_sourcekey = '';
        combat.retreat_destinationkey = '';
        this.mod.moveUnit(sourcekey, sourceidx, destinationkey, false);
        return;
      }
      var tracked = this.noteMove(faction, sourcekey, sourceidx, destinationkey);
      this.mod.moveUnit(sourcekey, sourceidx, destinationkey, !tracked);
    }
  }, {
    key: "attachRetreat",
    value: function attachRetreat(faction, destinationkey) {
      var place = destinationkey;
      if (this.mod.returnSpaceNameForLog && this.mod.game.spaces && this.mod.game.spaces[destinationkey]) {
        place = this.mod.returnSpaceNameForLog(destinationkey);
      }
      var lists = [];
      if (this.mod.log && this.mod.log.logs) {
        lists.push(this.mod.log.logs);
      }
      if (this.mod.game && this.mod.game.log) {
        lists.push(this.mod.game.log);
      }
      var seen = [];
      for (var n = 0; n < lists.length; n++) {
        var list = lists[n];
        for (var i = 0; i < list.length; i++) {
          var entry = list[i];
          if (!entry || entry.type !== 'combat' || !entry.data) {
            continue;
          }
          var already = false;
          for (var s = 0; s < seen.length; s++) {
            if (seen[s] === entry.data) {
              already = true;
            }
          }
          if (already) {
            break;
          }
          seen.push(entry.data);
          if (!Array.isArray(entry.data.retreats)) {
            entry.data.retreats = [];
          }
          var found = false;
          for (var j = 0; j < entry.data.retreats.length; j++) {
            if (entry.data.retreats[j].place === place) {
              found = true;
            }
          }
          if (!found) {
            entry.data.retreats.push({
              faction: faction,
              place: place
            });
          }
          break;
        }
      }
      if (this.mod.log && this.mod.log.rendered) {
        this.mod.log.render();
      }
    }
  }, {
    key: "flushIfBatchEnded",
    value: function flushIfBatchEnded() {
      var queue = this.mod.game.queue;
      var next = queue && queue.length ? queue[queue.length - 1] : '';
      var cmd = next ? String(next).split('\t')[0] : '';
      if (cmd !== 'move' && cmd !== 'control') {
        this.flush();
      }
    }
  }, {
    key: "flush",
    value: function flush() {
      var rows = this.mod.game.state.pending_movement_log;
      if (!rows || !rows.length) {
        return;
      }
      var groups = [];
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var group = null;
        for (var j = 0; j < groups.length; j++) {
          if (groups[j].faction === row.faction) {
            group = groups[j];
            break;
          }
        }
        if (!group) {
          group = {
            faction: row.faction,
            hops: []
          };
          groups.push(group);
        }
        group.hops.push({
          faction: row.faction,
          unit: row.unit,
          from: row.from,
          to: row.to
        });
      }
      this.mod.game.state.pending_movement_log = [];
      for (var _i = 0; _i < groups.length; _i++) {
        var hops = groups[_i].hops;
        var n = hops.length;
        var summary = this.sideName(groups[_i].faction) + ' move ' + n + (n === 1 ? ' unit' : ' units');
        this.mod.updateLog(summary, 'movement', {
          hops: hops
        });
      }
    }
  }, {
    key: "combat",
    value: function combat() {
      if (!this.mod.game || !this.mod.game.state) {
        return null;
      }
      return this.mod.game.state.pending_combat_log || null;
    }
  }, {
    key: "openCombat",
    value: function openCombat() {
      var combat = this.mod.game.state.combat;
      if (!combat) {
        return null;
      }
      this.mod.game.state.pending_combat_log = {
        key: combat.key,
        location: this.mod.returnSpaceNameForLog(combat.key),
        attackerFaction: combat.attacking_faction,
        defenderFaction: combat.defending_faction,
        modifiers: [],
        cards: [],
        losses: [],
        retreats: [],
        flankFrom: this.mod.game.state.pending_flank_launch || '',
        notes: [],
        attackers: [],
        defenders: [],
        attackerCF: 0,
        defenderCF: 0,
        fortCF: 0,
        attackerTable: 'corps',
        defenderTable: 'corps',
        attack: null,
        defense: null,
        winner: 'none',
        flank: '',
        published: false
      };
      this.mod.game.state.pending_flank_launch = '';
      return this.mod.game.state.pending_combat_log;
    }

    // The flank announcement is queued as its own log line. Keep it on the combat record instead.
  }, {
    key: "absorbLog",
    value: function absorbLog(str) {
      if (typeof str !== 'string') {
        return false;
      }
      var marker = 'Flank Attack launched from:';
      if (str.indexOf(marker) !== 0) {
        return false;
      }
      this.noteFlankLaunch(str.slice(marker.length).trim());
      return true;
    }
  }, {
    key: "noteFlankLaunch",
    value: function noteFlankLaunch(from) {
      var name = from || '';
      if (name && this.mod.game.spaces && this.mod.game.spaces[name] && this.mod.returnSpaceNameForLog) {
        name = this.mod.returnSpaceNameForLog(name);
      }
      var rec = this.combat();
      if (rec) {
        rec.flankFrom = name;
        return true;
      }
      if (this.mod.game && this.mod.game.state) {
        this.mod.game.state.pending_flank_launch = name;
      }
      return true;
    }
  }, {
    key: "abandonCombat",
    value: function abandonCombat() {
      if (this.mod.game && this.mod.game.state) {
        this.mod.game.state.pending_combat_log = null;
      }
    }
  }, {
    key: "addModifier",
    value: function addModifier(text) {
      var rec = this.combat();
      if (!rec || !text) {
        return;
      }
      rec.modifiers.push(text);
    }
  }, {
    key: "recordCard",
    value: function recordCard(side, html) {
      var rec = this.combat();
      if (!rec || !html) {
        return;
      }
      rec.cards.push({
        side: side,
        html: html
      });
    }
  }, {
    key: "note",
    value: function note(text) {
      var rec = this.combat();
      if (!rec || !text) {
        return;
      }
      rec.notes.push(text);
    }

    // Casualties that currently become their own log lines, once fire has been recorded.
  }, {
    key: "noteLoss",
    value: function noteLoss(text, faction) {
      var rec = this.combat();
      if (!rec || !rec.attack || !text) {
        return false;
      }
      rec.losses.push({
        text: text,
        faction: faction || ''
      });
      return true;
    }
  }, {
    key: "unitCF",
    value: function unitCF(unit) {
      if (!unit || unit.destroyed) {
        return 0;
      }
      if (unit.moved) {
        return 0;
      }
      if (unit.damaged) {
        return unit.rcombat || 0;
      }
      return unit.combat || 0;
    }
  }, {
    key: "unitLine",
    value: function unitLine(unit, fromKey) {
      if (!unit || unit.destroyed) {
        return '';
      }
      var line = this.label(unit.name);
      if (fromKey) {
        line += ' (' + this.mod.returnSpaceNameForLog(fromKey) + ')';
      }
      line += ' ' + this.unitCF(unit);
      if (unit.damaged) {
        line += ', reduced';
      }
      if (unit.moved) {
        line += ', already moved';
      }
      return line;
    }
  }, {
    key: "terrainNotes",
    value: function terrainNotes(spacekey) {
      var space = this.mod.game.spaces[spacekey];
      var notes = [];
      if (!space) {
        return notes;
      }
      if (space.terrain == 'mountain') {
        notes.push('mountain: attack column -1');
      }
      if (space.terrain == 'swamp') {
        notes.push('swamp: attack column -1');
      }
      if (this.mod.game.state.combat.cancel_trench_effects == 1) {
        if (space.trench > 0) {
          notes.push('trench effects cancelled');
        }
      } else if (space.trench == 1) {
        notes.push('trench: attack column -1, defense column +1');
      } else if (space.trench == 2) {
        notes.push('trench: attack column -1, defense column +2');
      }
      return notes;
    }
  }, {
    key: "fireColumn",
    value: function fireColumn(table, cf, shift) {
      var rows = table === 'corps' ? this.mod.returnCorpsFireTable() : this.mod.returnArmyFireTable();
      for (var i = rows.length - 1; i >= 0; i--) {
        if (rows[i].max >= cf && rows[i].min <= cf) {
          var col = i + shift;
          if (col <= 0) {
            col = 1;
          }
          if (col >= rows.length) {
            col = rows.length - 1;
          }
          var band = rows[col];
          if (band.min === band.max) {
            return String(band.min);
          }
          return band.min + '-' + band.max;
        }
      }
      return '';
    }
  }, {
    key: "describeFire",
    value: function describeFire(side) {
      var combat = this.mod.game.state.combat;
      var attacking = side === 'attacker';
      var cf = attacking ? combat.attacker_cp_at_fire : combat.defender_cp_at_fire;
      var table = attacking ? combat.attacker_table : combat.defender_table;
      var shift = attacking ? combat.attacker_column_shift : combat.defender_column_shift;
      var roll = attacking ? combat.attacker_roll : combat.defender_roll;
      var drm = attacking ? combat.attacker_drm : combat.defender_drm;
      var modified = attacking ? combat.attacker_modified_roll : combat.defender_modified_roll;
      var hits = attacking ? combat.defender_loss_factor_at_fire : combat.attacker_loss_factor_at_fire;
      return {
        cf: cf,
        table: table || 'corps',
        shift: shift || 0,
        column: this.fireColumn(table, cf, shift || 0),
        roll: roll,
        drm: drm || 0,
        modified: modified,
        hits: hits
      };
    }
  }, {
    key: "captureFire",
    value: function captureFire() {
      var rec = this.combat();
      if (!rec) {
        rec = this.openCombat();
      }
      if (!rec) {
        return;
      }
      var combat = this.mod.game.state.combat;
      var attackers = this.mod.returnAttackerUnits();
      var defenders = this.mod.returnDefenderUnits();
      rec.attackers = [];
      for (var i = 0; i < attackers.length; i++) {
        var unit = attackers[i];
        if (unit && !unit.destroyed) {
          rec.attackers.push({
            name: this.label(unit.name),
            cf: this.unitCF(unit)
          });
        }
      }
      rec.defenders = [];
      for (var _i2 = 0; _i2 < defenders.length; _i2++) {
        var _unit = defenders[_i2];
        if (_unit && !_unit.destroyed) {
          rec.defenders.push({
            name: this.label(_unit.name),
            cf: this.unitCF(_unit)
          });
        }
      }
      rec.attackerCF = combat.attacker_cp_at_fire;
      rec.defenderCF = combat.defender_cp_at_fire;
      rec.attackerTable = combat.attacker_table || 'corps';
      rec.defenderTable = combat.defender_table || 'corps';
      var unitCF = this.mod.returnDefenderCombatPower();
      rec.fortCF = rec.defenderCF - unitCF;
      if (rec.fortCF < 0) {
        rec.fortCF = 0;
      }
      var terrain = this.terrainNotes(combat.key);
      for (var _i3 = 0; _i3 < terrain.length; _i3++) {
        rec.modifiers.push(terrain[_i3]);
      }
      rec.attack = this.describeFire('attacker');
      rec.defense = this.describeFire('defender');
      rec.winner = combat.winner || 'none';
      rec.flank = combat.flank_attack || '';
    }
  }, {
    key: "resultText",
    value: function resultText(winner, attackerFaction, defenderFaction) {
      if (winner === 'attacker') {
        return this.sideName(attackerFaction) + ' victory';
      }
      if (winner === 'defender') {
        return this.sideName(defenderFaction) + ' victory';
      }
      return 'mutual loss';
    }
  }, {
    key: "fireLine",
    value: function fireLine(label, fire) {
      if (!fire) {
        return '';
      }
      var line = label + ': ' + fire.cf + ' CF ' + fire.table;
      if (fire.column) {
        line += ' column ' + fire.column;
      }
      if (fire.shift) {
        line += ' (' + (fire.shift > 0 ? '+' : '') + fire.shift + ')';
      }
      line += ', roll ' + fire.roll;
      if (fire.drm) {
        line += ' (' + (fire.drm > 0 ? '+' : '') + fire.drm + ') = ' + fire.modified;
      }
      line += ', ' + fire.hits + (fire.hits === 1 ? ' hit' : ' hits');
      return line;
    }
  }, {
    key: "publishCombat",
    value: function publishCombat() {
      var rec = this.combat();
      if (!rec || rec.published || !rec.attack) {
        return;
      }
      var combat = this.mod.game.state.combat;
      if (combat && combat.winner) {
        rec.winner = combat.winner;
      }
      rec.published = true;
      var attackerHits = rec.attack.hits;
      var defenderHits = rec.defense ? rec.defense.hits : 0;
      if (combat && typeof combat.defender_loss_factor === 'number' && typeof combat.attacker_loss_factor === 'number' && (combat.defender_loss_factor !== attackerHits || combat.attacker_loss_factor !== defenderHits)) {
        rec.notes.push('after flank losses: ' + combat.defender_loss_factor + ' hits on the defender, ' + combat.attacker_loss_factor + ' hits on the attacker');
        attackerHits = combat.defender_loss_factor;
        defenderHits = combat.attacker_loss_factor;
      }
      var result = this.resultText(rec.winner, rec.attackerFaction, rec.defenderFaction);
      var summary = this.sideName(rec.attackerFaction) + ' attack ' + rec.location;
      var data = {
        location: rec.location,
        attackerFaction: rec.attackerFaction,
        defenderFaction: rec.defenderFaction,
        attackers: rec.attackers,
        defenders: rec.defenders,
        attackerCF: rec.attackerCF,
        defenderCF: rec.defenderCF,
        attackerTable: rec.attackerTable,
        defenderTable: rec.defenderTable,
        fortCF: rec.fortCF,
        modifiers: rec.modifiers,
        cards: rec.cards,
        attack: rec.attack,
        defense: rec.defense,
        flank: rec.flank,
        flankFrom: rec.flankFrom || '',
        losses: rec.losses,
        retreats: rec.retreats || [],
        notes: rec.notes,
        winner: rec.winner,
        result: result,
        attackerHits: attackerHits,
        defenderHits: defenderHits
      };
      this.mod.game.state.pending_combat_log = null;
      this.mod.updateLog(summary, 'combat', data);
    }
  }, {
    key: "renderCombat",
    value: function renderCombat(entries) {
      var entry = entries && entries[0];
      if (!entry) {
        return '';
      }
      var combat = entry.data;
      if (!combat || !combat.attack) {
        return entry.msg || '';
      }
      var html = '';
      if (combat.flankFrom) {
        html += this.bullet('Flank Attack launched from ' + combat.flankFrom);
      }
      if (combat.modifiers) {
        for (var i = 0; i < combat.modifiers.length; i++) {
          if (String(combat.modifiers[i]).toLowerCase().indexOf('flank') === 0) {
            html += this.bullet(combat.modifiers[i]);
          }
        }
      }
      html += this.section('ATTACKING');
      html += this.unitBullets(combat.attackers);
      html += this.section('DEFENDING');
      html += this.unitBullets(combat.defenders);
      if (combat.fortCF > 0) {
        html += this.bullet('fort - ' + combat.fortCF);
      }
      var attackerHits = typeof combat.attackerHits === 'number' ? combat.attackerHits : combat.attack.hits;
      var defenderHits = typeof combat.defenderHits === 'number' ? combat.defenderHits : combat.defense ? combat.defense.hits : 0;
      html += this.section('HITS');
      html += this.bullet(this.sideName(combat.attackerFaction) + ' - ' + attackerHits);
      html += this.bullet(this.sideName(combat.defenderFaction) + ' - ' + defenderHits);
      html += this.lossSections(combat.losses);
      html += this.section('RESULT');
      html += this.bullet(this.winText(combat));
      html += this.retreatBullets(combat);
      html = this.gap() + html + this.gap();
      return this.fold('pog-combat', this.attackSummary(entry.msg), html);
    }

    // Older rows stored "Central Powers attack Sedan — Central Powers victory (5-3)".
  }, {
    key: "attackSummary",
    value: function attackSummary(msg) {
      var text = msg || '';
      var cut = text.indexOf(' — ');
      if (cut === -1) {
        cut = text.indexOf(' - ');
      }
      if (cut > 0) {
        return text.slice(0, cut);
      }
      return text;
    }
  }, {
    key: "gap",
    value: function gap() {
      return '<div class="pog-gap">&nbsp;</div>';
    }
  }, {
    key: "section",
    value: function section(title) {
      return '<div class="pog-section">' + title + '</div>';
    }
  }, {
    key: "bullet",
    value: function bullet(text) {
      return '<div>- ' + text + '</div>';
    }
  }, {
    key: "unitBullets",
    value: function unitBullets(units) {
      var html = '';
      if (!units) {
        return html;
      }
      for (var i = 0; i < units.length; i++) {
        var unit = units[i];
        if (unit && _typeof(unit) === 'object') {
          html += this.bullet(unit.name + ' - ' + unit.cf);
        } else if (unit) {
          html += this.bullet(unit);
        }
      }
      return html;
    }
  }, {
    key: "lossSections",
    value: function lossSections(losses) {
      var html = '';
      if (!losses || !losses.length) {
        return html;
      }
      var central = [];
      var allies = [];
      var other = [];
      for (var i = 0; i < losses.length; i++) {
        var loss = losses[i];
        var text = loss && _typeof(loss) === 'object' ? loss.text : loss;
        var faction = loss && _typeof(loss) === 'object' ? loss.faction : '';
        if (!text) {
          continue;
        }
        if (faction === 'central') {
          central.push(text);
        } else if (faction === 'allies') {
          allies.push(text);
        } else {
          other.push(text);
        }
      }
      html += this.lossBlock('LOSSES - CENTRAL', central);
      html += this.lossBlock('LOSSES - ALLIES', allies);
      html += this.lossBlock('LOSSES', other);
      return html;
    }
  }, {
    key: "lossBlock",
    value: function lossBlock(title, rows) {
      if (!rows.length) {
        return '';
      }
      var html = this.section(title);
      for (var i = 0; i < rows.length; i++) {
        html += this.bullet(rows[i]);
      }
      return html;
    }
  }, {
    key: "winText",
    value: function winText(combat) {
      if (combat.winner === 'attacker') {
        return this.sideName(combat.attackerFaction) + ' win';
      }
      if (combat.winner === 'defender') {
        return this.sideName(combat.defenderFaction) + ' win';
      }
      return 'mutual loss';
    }
  }, {
    key: "retreatBullets",
    value: function retreatBullets(combat) {
      var html = '';
      var retreats = combat.retreats || [];
      if (!retreats.length) {
        return html;
      }
      var places = [];
      var faction = combat.defenderFaction;
      for (var i = 0; i < retreats.length; i++) {
        if (retreats[i].faction) {
          faction = retreats[i].faction;
        }
        if (retreats[i].place && places.indexOf(retreats[i].place) === -1) {
          places.push(retreats[i].place);
        }
      }
      if (!places.length) {
        return html;
      }
      return this.bullet(this.sideName(faction) + ' retreat to ' + places.join(', '));
    }
  }, {
    key: "renderMovement",
    value: function renderMovement(entries) {
      var entry = entries && entries[0];
      if (!entry) {
        return '';
      }
      var hops = entry.data && entry.data.hops;
      if (!Array.isArray(hops) || !hops.length) {
        return entry.msg || '';
      }
      var rows = '';
      for (var i = 0; i < hops.length; i++) {
        rows += '<div>' + hops[i].unit + ' (' + hops[i].from + ' -> ' + hops[i].to + ')</div>';
      }
      return this.fold('pog-movement', entry.msg, rows);
    }

    // The shared log prefixes every row with ">". A block-level disclosure then
    // drops onto the next line, so the filled caret has to take that column itself.
    // Clicks on the summary stay with the disclosure. Clicks on the body reach the log.
  }, {
    key: "fold",
    value: function fold(kind, summary, body) {
      return '<details class="pog-log ' + kind + '"><summary>' + summary + '</summary>' + body + '</details>';
    }
  }]);
}();
module.exports = PathsLog;